module.exports = __webpack_public_path__ + "static/oval4.678fe758.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/oval4.png
// module id = 255
// module chunks = 0